angular.module('lf.common')

.directive('validCvc', function (validationService) {
  return {
    require: 'ngModel',
    link: function (scope, el, attrs, model) {
      var validator = function (val) {
        var cardNum = scope.$eval(attrs.validCvc);
        if(!validationService.creditCard.validateCreditCardNumber(cardNum)) {
        	// don't do validation yet..
        	model.$setValidity('cvc', true);
        	return val;
        }
        var valid = model.$isEmpty(val) || validationService.creditCard.validateCreditCardCvc(val, cardNum);
        model.$setValidity('cvc', valid);
        return val;
      }
      scope.$watch(attrs.validCvc, function(val) { 
        var modelValue = model.$modelValue;
        if (!model.$isEmpty(modelValue)) {
          validator(modelValue);
        }
      });
      model.$parsers.push(validator);
      model.$formatters.push(validator);
    }
  }
});
